export class Block {
    constructor(block) {
        if (block instanceof HTMLElement) {
            this.block = block;
        }
        else if (block && block[0] instanceof HTMLElement) {
            //assume that we're on wp-admin block editor or jQuery object
            this.block = block[0];
        }
        else {
            this.block = block;
        }
    }
    name() {
        return this.constructor.name;
    }
    adminReInit() { }
}
